import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { Address } from "../Entities/Address/Address";
import { AddressInterface } from "../Entities/Address/AddressInterface";

class AddressFactory extends Factory implements FactoryInterface {

  public create(data: any): AddressInterface {
    return new Address({
      id: data.id,
      googlePlaceId: data.googlePlaceId,
      countryIsoCode: data.countryIsoCode,
      country: data.country,
      postalCode: data.postalCode,
      administrativeAreaLevel1: data.administrativeAreaLevel1,
      administrativeAreaLevel2: data.administrativeAreaLevel2,
      administrativeAreaLevel3: data.administrativeAreaLevel3,
      administrativeAreaLevel1Long: data.administrativeAreaLevel1Long,
      administrativeAreaLevel2Long: data.administrativeAreaLevel2Long,
      administrativeAreaLevel3Long: data.administrativeAreaLevel3Long,
      route: data.route,
      routeLong: data.routeLong,
      locality: data.locality,
      localityLong: data.localityLong,
      sublocality: data.sublocality,
      sublocalityLong: data.sublocalityLong,
      sublocalityLevel1: data.sublocalityLevel1,
      sublocalityLevel2: data.sublocalityLevel2,
      sublocalityLevel1Long: data.sublocalityLevel1Long,
      sublocalityLevel2Long: data.sublocalityLevel2Long,
      formattedAddress: data.formattedAddress,
      lat: data.lat,
      lng: data.lng,
      streetNumber: data.streetNumber,
      fullAddress: data.fullAddress
    });
  }

  public reinitialize(data: any): AddressInterface {
    return new Address({
      ...data
    });
  }
}

export default new AddressFactory();
